// Single source of truth for public contact info.
// Import from here instead of hardcoding strings in components.
export const CONTACT = {
  email: 'info@ospitohms.com',
  supportEmail: 'support@ospitohms.com',
  phoneDisplay: '+256767641749',
  phoneTel: '+256767641749',
  whatsappDisplay: '+256747211702',
  whatsappUrl: 'https://wa.me/256747211702',
};
